import React, { useMemo, useState } from 'react';
import ChartV2 from 'components/ChartV2';
import Loading from 'components/Loading/Loading';
import Row from 'components/Common/Row';
import FlexCentered from 'components/Common/FlexCentered';
import Typography from 'kingpin/atoms/Typography';
import Inputs from 'components/Inputs';
import DATASET_TREND_BUTTON from '../constants';
import useOptions from './useOptions';
import Tooltip from './Tooltip';
import useChartTitle from './useChartTitle';
import useFieldOptions from './useFieldOptions';
import buildMetric from './buildMetric';
import useAggFuncOptions from './useAggFuncOptions';

const DatasetTrendContainer = ({ dataset }: { dataset: string }) => {
  const [fieldAndAggFunc, setFieldAndAggFunc] = useState<{
    field: string;
    aggFunc: AggFunc;
  }>({
    field: DATASET_TREND_BUTTON.DEFAULT_FIELD,
    aggFunc: 'count',
  });
  const { aggFuncOptions, setAcceptedAggFuncs } = useAggFuncOptions({
    fieldAndAggFunc,
    setFieldAndAggFunc,
  });
  const { fieldOptions } = useFieldOptions({
    dataset,
    fieldAndAggFunc,
    setFieldAndAggFunc,
    setAcceptedAggFuncs,
  });
  const metric = useMemo(() => {
    return buildMetric({
      dataset,
      field: fieldAndAggFunc.field,
      aggFunc: fieldAndAggFunc.aggFunc,
    });
  }, [dataset, fieldAndAggFunc.aggFunc, fieldAndAggFunc.field]);

  const { options, isLoading, interval } = useOptions({
    metric,
  });
  const title = useChartTitle({ interval, metric });

  return (
    <>
      <Row centerAlign spaceBetween style={{ marginBottom: 12 }}>
        <Typography.Header type="H5">{title}</Typography.Header>
        <Row centerAlign style={{ gap: 8 }}>
          <Inputs.Dropdown options={fieldOptions} isSearchEnabled />
          <Inputs.Dropdown options={aggFuncOptions} />
        </Row>
      </Row>
      <div
        style={{
          height: DATASET_TREND_BUTTON.TREND_HEIGHT,
        }}
      >
        {isLoading && (
          <FlexCentered style={{ height: '100%' }}>
            <Loading />
          </FlexCentered>
        )}
        {!isLoading && (
          <ChartV2
            options={options}
            TooltipComponent={Tooltip}
            testId="dataset-search-trend"
          />
        )}
      </div>
    </>
  );
};

export default DatasetTrendContainer;
